import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'

Vue.config.productionTip = false

/* prevent unknown custom element error */
Vue.config.ignoredElements = [
  'a-scene',
  'a-assets',
  'a-entity',
  'a-marker',
  'a-video',
  'a-plane'
]

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
